export default __webpack_public_path__ + "static/insights-link-icon1.url-8d1a311fcf18eca11875b1685e342091.svg";